var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"chart-container"},[_c('canvas',{ref:"activityChart"})]),_c('p',{staticClass:"text-center",staticStyle:{"margin-top":"10px"}},[_vm._v("\n        Activities Breakdown "),_c('br'),_vm._v("\n        Completed: "+_vm._s(_vm.totalCompleted)+" | Overdue: "+_vm._s(_vm.totalIncomplete)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }